import { render, staticRenderFns } from "./AvatarInstructor.vue?vue&type=template&id=2988994d&scoped=true"
import script from "./AvatarInstructor.vue?vue&type=script&lang=ts"
export * from "./AvatarInstructor.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2988994d",
  null
  
)

export default component.exports